export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_MAX_LENGTH = 20

export const ERROR_PASSWORD_NOT_JUST_WHITESPACE =
  'Password cannot be just whitespace.'
export const ERROR_PASSWORD_MIN_LENGTH = `Too short, use at least ${PASSWORD_MIN_LENGTH} characters`
export const ERROR_PASSWORD_MAX_LENGTH = `Password is too long. Use at most ${PASSWORD_MAX_LENGTH} characters. You typed {charsTyped} characters.`
